<label [for]="for">{{ label }}</label>
<div class="content"><ng-content /></div>
